import { reservedForTechnicalUsageFields } from "../PathConstants";

import {
    AbsoluteModelPath,
    createAbsoluteFromTokens,
    createRelativeFromTokens,
    createModelPath,
    ModelPath,
    PathToken,
    PathTokens,
} from "./ModelPath";

export function isAggregationPath(modelPath: ModelPath) {
    const tokens = modelPath.getPathPartsAsArray();
    const lastToken = tokens[tokens.length - 1];
    return lastToken === "Sum" || lastToken === "Count";
}

export function getMask(exactPath: AbsoluteModelPath): AbsoluteModelPath {
    return createAbsoluteFromTokens(
        Iterator.from(exactPath.getPathParts())
            .map(x => (PathTokens.isInstanceToken(x) ? PathTokens.each : x))
            .toArray()
    );
}

export function getMaskWithInstances(exactPath: AbsoluteModelPath): {
    mask: AbsoluteModelPath;
    instances: PathToken[];
} {
    const reduceResult = Iterator.from(exactPath.getPathParts()).reduce(
        (result, token) => {
            if (PathTokens.isInstanceToken(token) || PathTokens.isMultiToken(token)) {
                result.instances.push(token);
            }
            result.tokens.push(PathTokens.isInstanceToken(token) ? PathTokens.each : token);
            return result;
        },
        {
            tokens: [] as PathToken[],
            instances: [] as PathToken[],
        }
    );
    return {
        mask: createAbsoluteFromTokens(reduceResult.tokens),
        instances: reduceResult.instances,
    };
}

export function replaceInstancesWithMultiplicity<T extends ModelPath>(
    path: T,
    replaceToken: typeof PathTokens.each | typeof PathTokens.current = PathTokens.each
): T {
    const isAbsolute = path.isAbsolute();
    const resultTokens = path.getPathPartsAsArray().map(x => (PathTokens.isInstanceToken(x) ? replaceToken : x));
    return isAbsolute ? (createAbsoluteFromTokens(resultTokens) as T) : (createRelativeFromTokens(resultTokens) as T);
}

export function checkIsReservedPath(path: AbsoluteModelPath): boolean {
    return reservedForTechnicalUsageFields.some(field => path.endsWith(createModelPath(field, false)));
}
